import React, { useEffect, useState } from "react";
import { api, errMsg, fmtNum } from "@finance/lib/api";
import { toast } from "sonner";
import { Button } from "@finance/components/ui/button";
import { Input } from "@finance/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@finance/components/ui/dialog";

export function ReceiptWhtDialog({ inv, onClose, onDone }) {
  const [p, setP] = useState(null);
  const [rate, setRate] = useState("");
  const [f, setF] = useState({ bank_account_id: "", payment_date: new Date().toISOString().slice(0, 10), batch_no: "" });
  const [banks, setBanks] = useState([]);
  useEffect(() => { if (inv) { api.get("/bank-accounts").then((r) => setBanks(r.data)).catch(() => {}); } }, [inv]);
  useEffect(() => {
    if (!inv) return;
    api.get(`/wht/receipt-preview/${inv.id}`, { params: rate === "" ? {} : { rate } }).then((r) => { setP(r.data); if (rate === "") setRate(String(r.data.rate)); }).catch((e) => toast.error(errMsg(e)));
  }, [inv, rate]);
  if (!inv) return null;
  const save = async () => {
    if (!f.bank_account_id) { toast.error("Select the bank account."); return; }
    try {
      await api.post("/payments", { transaction_id: p.transaction_id, client_invoice_id: inv.id, direction: "receivable", amount: p.cash, wht_amount: p.wht, wht_rate: Number(rate),
        currency: p.currency, fx_rate: 1, payment_method: "bank", ...f });
      toast.success("Receipt with WHT recorded — invoice settled"); onDone?.(); onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="receipt-wht-dialog">
        <DialogHeader><DialogTitle>Receipt with WHT — {inv.invoice_no}</DialogTitle></DialogHeader>
        {p && <div className="space-y-1 rounded-sm bg-gray-50 p-3 text-sm" data-testid="receipt-wht-preview">
          <div className="flex justify-between"><span>Invoice total (stays as issued)</span><b>{fmtNum(p.total)}</b></div>
          <div className="flex justify-between"><span>Outstanding</span><span>{fmtNum(p.outstanding)}</span></div>
          <div className="flex justify-between"><span>WHT on VAT-exclusive {fmtNum(p.exclusive)}</span><span className="text-indigo-700">− {fmtNum(p.wht)}</span></div>
          <div className="flex justify-between border-t pt-1"><span>Cash to bank</span><b data-testid="receipt-wht-cash">{fmtNum(p.cash)}</b></div>
          <div className="text-[11px] text-gray-500">Posts Dr Bank (cash) / Dr 1350 WHT Receivable / Cr AR (cash + WHT).</div>
        </div>}
        <div className="grid grid-cols-2 gap-3">
          <div><div className="lx-label">WHT rate %</div><Input type="number" className="mt-1" data-testid="receipt-wht-rate" value={rate} onChange={(e) => setRate(e.target.value)} /></div>
          <div><div className="lx-label">Date</div><Input type="date" className="mt-1" value={f.payment_date} onChange={(e) => setF({ ...f, payment_date: e.target.value })} /></div>
          <div className="col-span-2"><div className="lx-label">Bank</div><select className="mt-1 h-9 w-full rounded-sm border border-gray-200 px-2 text-sm" data-testid="receipt-wht-bank" value={f.bank_account_id} onChange={(e) => setF({ ...f, bank_account_id: e.target.value })}><option value="">Select…</option>{banks.map((b) => <option key={b.id} value={b.id}>{b.bank_name} · {b.account_number} ({b.currency})</option>)}</select></div>
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button><Button className="bg-[#1B4383]" data-testid="receipt-wht-save" disabled={!p || p.cash <= 0} onClick={save}>Record receipt</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
